import { browser } from "$app/environment";

export const isAndroid =
  browser &&
  (window.oprt?.gxCornerConfig?.platform === "android" ||
    navigator.userAgent.match(/android/i));
export const isIos =
  browser &&
  (window.oprt?.gxCornerConfig?.platform === "ios" ||
    navigator.userAgent.match(/(iPad|iPhone|iPod)/i));
export const isDesktop = browser && !isAndroid && !isIos;
export const isWebView = browser && !!window.oprt?.gxCornerConfig;
